import { useEffect } from 'react';

const handleBeforeunload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  // Included for legacy support, e.g. Chrome/Edge < 119
  event.returnValue = true;
};

export const useBeforeUnload = () => {
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeunload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, []);
};
